import "./ProjectsSection.css";
import React, { useEffect } from "react";
import Aos from "aos";
import "aos/dist/aos.css";
import { AiFillGithub } from "react-icons/ai";
import { FiExternalLink } from "react-icons/fi";

const ProjectsSection = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <>
      {/* ================= TOP PROJECTS ================= */}
      <section className="section-feature">
        <div className="row">
          <div data-aos="fade-up" className="col-1-of-3">
            <div className="feature-box">
              <h3>Covid Tracker</h3>
              <hr />
              <p>
                This project shows daily updated country-level information
                related to COVID cases, new deaths and total deaths across the
                world. The API updates every 24 hours.
              </p>

              <div className="technologyused">
                <p>HTML</p>
                <p>CSS</p>
                <p>JavaScript</p>
              </div>

              <div className="projectlink">
                <li>
                  <a href="https://github.com/chandan-singh02/covidtracker">
                    <AiFillGithub />
                  </a>
                </li>
                <li>
                  <a href="https://covidtracker-sigma.vercel.app/">
                    <FiExternalLink />
                  </a>
                </li>
              </div>
            </div>
          </div>

          <div data-aos="fade-up" className="col-1-of-3">
            <div className="feature-box">
              <h3>Random Choice Picker</h3>
              <hr />
              <p>
                Random choice picker selects a choice from a list of items you
                provide. Separate items using commas (,).
              </p>

              <div className="technologyused">
                <p>HTML</p>
                <p>CSS</p>
                <p>JavaScript</p>
              </div>

              <div className="projectlink">
                <li>
                  <a href="https://github.com/chandan-singh02/choicepicker">
                    <AiFillGithub />
                  </a>
                </li>
                <li>
                  <a href="https://choicepicker.vercel.app/">
                    <FiExternalLink />
                  </a>
                </li>
              </div>
            </div>
          </div>

          <div data-aos="fade-up" className="col-1-of-3">
            <div className="feature-box">
              <h3>Guess the Number?</h3>
              <hr />
              <p>
                This project was made while learning DOM concepts, inspired by{" "}
                <a href="https://twitter.com/jonasschmedtman">
                  Jonas Schmedtmann
                </a>
                . The user guesses a random number between 1 and 20.
              </p>

              <div className="technologyused">
                <p>HTML</p>
                <p>CSS</p>
                <p>JavaScript</p>
              </div>

              <div className="projectlink">
                <li>
                  <a href="https://github.com/chandan-singh02/Guess-The-No.">
                    <AiFillGithub />
                  </a>
                </li>
                <li>
                  <a href="https://guess-the-no-seven.vercel.app/">
                    <FiExternalLink />
                  </a>
                </li>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ================= OTHER PROJECTS ================= */}
      <section className="section-features">
        <h1>Some Others Too--</h1>

        <div data-aos="fade-up" className="col-3-of-4">
          <div className="feature-box features-bottom">
            <h3>Tesla Clone UI</h3>
            <hr />
            <p className="feature-box__text">
              This is my first project built while learning HTML and CSS. After
              completing the basics, I tried recreating the UI of a famous tech
              company.
            </p>

            <div className="projectlinks">
              <li>
                <a href="https://github.com/chandan-singh02/teslaclone">
                  <AiFillGithub />
                </a>
              </li>
              <li>
                <a href="https://teslaclone-snowy.vercel.app/">
                  <FiExternalLink />
                </a>
              </li>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ProjectsSection;
